module.exports = __webpack_public_path__ + "static/media/02_enbrain_info.b4a9d77d.png";